import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { MasterService } from "src/app/services/master.service";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { UserResponseModel } from "src/app/model/UserResponseModel";
import { log } from "console";

@Component({
  selector: "app-secure-user-au",
  templateUrl: "./user-au.component.html",
  styleUrls: ["./user-au.component.scss"],
})
export class UserAUComponent implements OnInit {
  userKey: number;
  pageMode: string;
  userModel : UserResponseModel;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  roles: {[key: number]: string};
  boards: {[key: number]: string};
  usernamePattern: string = "^[A-Z]+[0-9]+_$";
  // boardWiseDepartments: {[key: number]: {[key: number]: string}};
  // departmentWiseDesignations: {[key: number]: {[key: number]: string}};

  constructor(
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.masterService
    .initUserForm()
    .subscribe((data: any) => {
      if(data.status === 'SUCCESS') {
        this.roles = data.roles;
        this.boards = data.boards;
        // this.boardWiseDepartments = data.boardWiseDepartments;
        // this.departmentWiseDesignations = data.departmentWiseDesignations;
        
        this.route.params.subscribe((params: Params) => {
          this.userKey = +params["key"];      
          if(this.userKey) {
            this.masterService
            .getUserBykey(this.userKey)
            .subscribe((data: any) => {
              this.userModel = data;
              this.pageMode = "Edit";
              console.log("this.userModel ",this.userModel );
              
              this.form.patchValue({
                userId: this.userModel.userId,
                userName: this.userModel.userName,
                roleList: Object.keys(this.userModel.roleList).map(key => ({
                  key: key,
                  value: this.userModel.roleList[key]
                })),
                employer: this.userModel.employer,
                mobileNumber: this.userModel.mobileNumber,
                emailId: this.userModel.emailId,
              });
            
              let selecteduserAddressLst: FormArray = this.form.get('userAddressLst') as FormArray;
              this.userModel.userAddress.forEach((ur) => {         
                let address = {
                  // key: ur.key,
                  value: ur.userAddress
                };

                selecteduserAddressLst.push(new FormGroup({
                  key: new FormControl(ur.key),
                  userAddress: new FormControl(address.value, Validators.required),
                }));
              });

              let selectedUserResponsibilityLst: FormArray = this.form.get('userResponsibilityLst') as FormArray;
             
              this.userModel.userResponsibilities.forEach(ur => {
                let board = {
                  key: ur.boardKey,
                  value: ur.boardCodeName
                };
                // let department = {
                //   key: ur.departmentKey,
                //   value: ur.departmentName
                // };
                // let designation = {
                //   key: ur.designationKey,
                //   value: ur.designationName
                // };

                selectedUserResponsibilityLst.push(new FormGroup({
                  key: new FormControl(ur.key),
                  boardKey: new FormControl(board, Validators.required),
                  // departmentKey: new FormControl(department, Validators.required),
                  // designationKey: new FormControl(designation, Validators.required) ,
                }));


              });
            });
          }
          else {
            this.pageMode = "Add";
          }
        });
      }
      else {
        this.errorToast(data.errorMessage, 5*1000);
      }
    });
    this.form = new FormGroup({
      userId: new FormControl(null, [Validators.required, Validators.maxLength(300)]),
      userName: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      roleList: new FormControl(null, Validators.required),
      employer: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      mobileNumber: new FormControl(null, [Validators.required, Validators.pattern(/^[0-9]+$/), Validators.minLength(10), Validators.maxLength(10)]),
      emailId: new FormControl(null, [Validators.required, Validators.email, Validators.maxLength(255)]),
      userResponsibilityLst: new FormArray([]),
      userAddressLst: new FormArray([]),
    });
  }

  onSubmit() {
    if (this.form.valid) {
      if(this.pageMode === 'Add') {
        this.save();
      }
      else {
        this.update();
      }
    } 
    else {
      this.isSubmitDisabled = false;
    }
  }

  async save() {
    this.masterService
    .saveUser({
      userId: this.form.value.userId.toUpperCase(),
      userName: this.form.value.userName,
      roleList: this.form.value.roleList.map(
        r => r.key
      ),
      employer: this.form.value.employer,
      mobileNumber: this.form.value.mobileNumber,
      emailId: this.form.value.emailId,
      userResponsibilityLst: this.form.value.userResponsibilityLst.map(ur => ({
        key: ur.key,
        boardKey: ur.boardKey.key,
        // departmentKey: ur.departmentKey.key,
        // designationKey: ur.designationKey.key,

      })),
      userAddressLst: this.form.value.userAddressLst.map(ur => ({
        userAddress: ur.userAddress,

      }))
    })
    .subscribe((data: any) => {
        if(data.status === 'SUCCESS') {
          this.successToast();
          this.router.navigate(["/secure", "master", "user", "list"]);
        }
        else {
          this.isSubmitDisabled = false;
          this.errorToast(data.errorMessage);
        }
      }, error => {
        this.isSubmitDisabled = false;
        console.log(error);
        this.errorToast(error.error.errorMessage, 5*1000);
      });  
  }

  async update() {
    this.masterService
    .updateUser(this.userKey, {
      userId: this.form.value.userId.toUpperCase(),
      userName: this.form.value.userName,
      roleList: this.form.value.roleList.map(
        r => r.key
      ),
      employer: this.form.value.employer,
      mobileNumber: this.form.value.mobileNumber,
      emailId: this.form.value.emailId,
      userResponsibilityLst: this.form.value.userResponsibilityLst.map(ur => ({
        key: ur.key,
        boardKey: ur.boardKey.key,
        // departmentKey: ur.departmentKey.key,
        // designationKey: ur.designationKey.key
      })),
      userAddressLst: this.form.value.userAddressLst.map(ur => ({
        key: ur.key,
        userAddress: ur.userAddress
      }))

    }).subscribe((data: any) => {
      if(data.status === 'SUCCESS') {
        this.successToast();
        this.router.navigate(["/secure", "master", "user", "list"]);
      }
      else {
        this.isSubmitDisabled = false;
        this.errorToast(data.errorMessage);
      }
    }, error => {
      this.isSubmitDisabled = false;
      console.log(error);
      this.errorToast(error.error.errorMessage, 5*1000);
    });    
  }

  async successToast() {
    await this._snackBar.open(
      "User saved successfully.",
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }

  showRoles(o1: any, o2: any) {
    // console.log(o1, o2);
    if(o1 && o2 && o1.key == o2.key) {
      return o1.value;
    }
    else {
      return "";
    }
  }

  showBDD(o1: any, o2: any) {    
    if(o1 && o2 && o1.key == o2.key) {
      return o1.value;
    }
    else {
      return "";
    }
  }

  addResponsibility() {
    let selectedUserResponsibilityLst: FormArray = this.form.get('userResponsibilityLst') as FormArray;
    selectedUserResponsibilityLst.push(new FormGroup({
      key: new FormControl(null),
      boardKey: new FormControl(null, Validators.required),
      // departmentKey: new FormControl(null, Validators.required),
      // designationKey: new FormControl(null, Validators.required),
    }));
  }

  deleteResponsibility(i: number) {
    let selectedUserResponsibilityLst: FormArray = this.form.get('userResponsibilityLst') as FormArray;
    selectedUserResponsibilityLst.removeAt(i);
  }

  get responsibilities() {
    return this.form.get('userResponsibilityLst')['controls'];
  }

  // departments(i: number) {
  //   let selectedUserResponsibilityLst: FormArray = this.form.get('userResponsibilityLst') as FormArray;
  //   return this.boardWiseDepartments[selectedUserResponsibilityLst.controls[i].value.boardKey?.key];
  // }

  // designations(i: number) {
  //   let selectedUserResponsibilityLst: FormArray = this.form.get('userResponsibilityLst') as FormArray;
  //   return this.departmentWiseDesignations[selectedUserResponsibilityLst.controls[i].value.departmentKey?.key];
  // }

  addAddress() {
    let selecteduserAddressLst: FormArray = this.form.get('userAddressLst') as FormArray;
    if (selecteduserAddressLst.length < 5) {
    selecteduserAddressLst.push(new FormGroup({
        key: new FormControl(null),
        userAddress: new FormControl(null, Validators.required), // Add this line to create the userAddress control

    }));
  } else {
    this.errorToast("Maximum limit reached");
    }
}

  deleteAddress(i: number) {
    let selecteduserAddressLst: FormArray = this.form.get('userAddressLst') as FormArray;
    selecteduserAddressLst.removeAt(i);
  }

  get addresses() {
    return this.form.get('userAddressLst')['controls'];
  }

// VALIDATION'S

  validateUserName(event: KeyboardEvent): boolean {
    const input = event.key;

    if (!/^[a-zA-Z0-9_]$/.test(input)) {
      return false;
    }

    const value = (event.target as HTMLInputElement).value + input;

    if (!/^[a-zA-Z0-9_]+$/.test(value)) {
      return false;
    }

    return true;
  }

  convertToUpper(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.toUpperCase();
  }


}